import { BaseWebsite } from '../core/BaseWebsite.js';
import { gsap } from 'gsap';

export class IndexPage extends BaseWebsite {
  constructor() {
    super();
    this.setupIndexSpecific();
  }

  setupIndexSpecific() {
    this.setupHeroAnimations();
    this.setupHeroPinReveal('#hero', '#intro');
    this.setupIntroAnimation();
    this.setupProjectsReordering();
  }

  setupHeroAnimations() {
    // Hero title animation
    const heroLines = gsap.utils.toArray('.hero-line');
    const heroSubtitle = document.querySelector('.hero-subtitle');
    const heroButton = document.querySelector('.hero-button');

    // Set initial states for animation but keep CSS visibility control until animation
    gsap.set(heroLines, { y: 100, opacity: 0 });
    gsap.set(heroSubtitle, { y: 50, opacity: 0 });
    gsap.set(heroButton, { y: 30, opacity: 0 });

    const tl = gsap.timeline({
      delay: 0.5,
      onStart: () => {
        // Set visibility at the very beginning of the timeline
        document.documentElement.style.setProperty('--hero-visibility', 'visible');
      }
    });

    tl.to(heroLines, {
      y: 0,
      opacity: 1,
      duration: 1.2,
      stagger: 0.2,
      ease: "power2.out"
    })
    .to(heroSubtitle, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "power2.out"
    }, "-=0.6")
    .to(heroButton, {
      y: 0,
      opacity: 1,
      duration: 0.8,
      ease: "power2.out"
    }, "-=0.4");

    // Parallax effect on hero background
    const heroBg = document.querySelector('.hero-bg');
    if (heroBg) {
      gsap.to('.hero-bg', {
        yPercent: -50,
        ease: "none",
        scrollTrigger: {
          trigger: ".hero-section",
          start: "top bottom",
          end: "bottom top",
          scrub: true
        }
      });
    }
  }

  // (setupClientLogos entfernt: das Logo-Raster laeuft jetzt als Item-Gruppe
  // im Sektions-Reveal von BaseWebsite mit - ein zweiter Tween wuerde kaempfen.)

  setupProjectsReordering() {
    // Project image reordering logic for better visual layout
    const reorderImages = () => {
      const projects = gsap.utils.toArray('.project-section');
      projects.forEach((project, index) => {
        const layout = project.querySelector('.project-layout');
        if (layout) {
          if (index % 2 === 1) {
            layout.classList.add('project-layout-reverse');
          } else {
            layout.classList.remove('project-layout-reverse');
          }
        }
      });
    };

    reorderImages();
    
    // Reorder on window resize
    window.addEventListener('resize', reorderImages);
  }
}